import React from "react";
import { Box, Typography } from "@mui/material";
import { DumontLogo } from "../../../Generic/Icons";

export default function DispatchWelcome() {
  return (
    <Box
      sx={{
        width: "389px",
        height: "158.56px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          alignSelf: "stretch",
          gap: "4px",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            width: "40px",
            height: "40px",
            borderRadius: "4px",
          }}
        >
          <DumontLogo size={40} />
        </Box>

        {/* Frame4324 */}
        <Box
          sx={{
            width: "100%",
            height: "106.56px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Título "Dumont AI" */}
          <Box
            sx={{
              marginTop: "8px",
              width: "389px",
              height: "28px",
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Manrope",
                fontSize: "20px",
                fontWeight: 500,
                lineHeight: "1.4em",
                color: "#475467",
                textAlign: "center",
                width: "100%",
              }}
            >
              Dumont
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
